import { render, staticRenderFns } from "./PhoneInputBox.vue?vue&type=template&id=04a7763b&"
import script from "./PhoneInputBox.vue?vue&type=script&lang=js&"
export * from "./PhoneInputBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports